export const ACTION_TYPES = {
  FILTER_EKYC: Symbol("FILTER_EKYC"),
  SET_FILTER_EKYC_STATE: Symbol("SET_FILTER_EKYC_STATE"),
  SET_EKYC_LIST: Symbol("SET_EKYC_LIST"),
  DOWNLOAD_EKYC_LIST: Symbol("DOWNLOAD_EKYC_LIST"),
  SET_DOWNLOAD_EKYC_LIST_STATE: Symbol("SET_DOWNLOAD_EKYC_LIST_STATE"),
  IMPORT_EKYC: Symbol("IMPORT_EKYC"),
  SET_IMPORT_EKYC_STATE: Symbol("SET_IMPORT_EKYC_STATE"),
  SEND_EMAIL_EKYC_RESULT: Symbol("SEND_EMAIL_EKYC_RESULT"),
  SET_SEND_EMAIL_EKYC_RESULT_STATE: Symbol("SET_SEND_EMAIL_EKYC_RESULT_STATE"),
  FILTER_HEALTH_CHECK: Symbol("FILTER_HEALTH_CHECK"),
  SET_FILTER_HEALTH_CHECK_STATE: Symbol("SET_FILTER_HEALTH_CHECK_STATE"),
  SET_HEALTH_CHECK_LIST: Symbol("SET_HEALTH_CHECK_LIST"),
  GET_FILTER_OPTIONS: Symbol("GET_FILTER_OPTIONS"),
  SET_FILTER_OPTIONS: Symbol("SET_FILTER_OPTIONS"),
  CONFIRM_BATCH_HEALTH_CHECK: Symbol("CONFIRM_BATCH_HEALTH_CHECK"),
  SET_CONFIRM_BATCH_HEALTH_CHECK_STATE: Symbol("SET_CONFIRM_BATCH_HEALTH_CHECK_STATE"),
  SEND_EMAIL_BATCH_HEALTH_CHECK: Symbol("SEND_EMAIL_BATCH_HEALTH_CHECK"),
  SET_SEND_EMAIL_BATCH_HEALTH_CHECK_STATE: Symbol("SET_SEND_EMAIL_BATCH_HEALTH_CHECK_STATE"),
  GET_PERSONAL_HEALTH_CHECK_DETAILS: Symbol("GET_PERSONAL_HEALTH_CHECK_DETAILS"),
  SET_PERSONAL_HEALTH_CHECK_DETAILS: Symbol("SET_PERSONAL_HEALTH_CHECK_DETAILS"),
  CONFIRM_HEALTH_CHECK: Symbol("CONFIRM_HEALTH_CHECK"),
  SET_CONFIRM_HEALTH_CHECK_STATE: Symbol("SET_CONFIRM_HEALTH_CHECK_STATE"),
  GET_DETAILS: Symbol("GET_DETAILS"),
  SET_DETAILS: Symbol("SET_DETAILS"),
  EXPORT_PDF_DETAILS: Symbol("EXPORT_PDF_DETAILS"),
  SEND_EMAIL_HEALTH_CHECK: Symbol("SEND_EMAIL_HEALTH_CHECK"),
  SET_SEND_EMAIL_HEALTH_CHECK_STATE: Symbol("SET_SEND_EMAIL_HEALTH_CHECK_STATE"),
  GET_FILTER_EKYC_OPTIONS: Symbol("GET_FILTER_EKYC_OPTIONS"),
  SET_FILTER_EKYC_OPTIONS: Symbol("SET_FILTER_EKYC_OPTIONS"),
};
